import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  email: yup.string().email().required('Please enter email'),
  password: yup.string().required('Please enter a password'),
});

export const signUpSchema = yup.object().shape({
  email: yup.string().email().required('Please enter email'),
  password: yup
    .string()
    .required('Please enter a password')
    .min(6)
    .max(20)
    .matches(
      /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+){6,}$/,
      'Password must have at least 6 charachters length, letter, digit'
    ),
  confirmPassword: yup.string().oneOf([yup.ref('password'), null]),
});
